////import React from 'react';

////import { Routes, Route } from 'react-router-dom';

////import { UserProvider } from './components/Context/UserContext';

////import { Home } from './components/Home';

////import Login from './components/Login';

////import SignUp from './components/SignUp';

////import MasterPage from './components/MasterPage';

////import NavMenu from './components/NavMenu';
////import Vendors from './components/Vendors';
////import ViewAllVendors from './components/ViewAllVendors';
////import ViewAllUsers from './components/ViewAllUsers';
////import VendorsList from './components/VendorsList';
////import ViewAllInvoice from './components/ViewAllInvoice';
////import Reports from '.././src/components/Reports';
////import ViewAllVendorReports from './components/ViewAllVendorReports';
////import ViewAllInvoiceDetails from './components/ViewAllInvoiceDetails';
////import './custom.css';

////function App() {

////    return (
////        <UserProvider>
////            <NavMenu />
////            <Routes>
////                <Route path="/" element={<Home />} />
////                <Route path="/login" element={<Login />} />
////                <Route path="/master-page" element={<MasterPage />} />
////                <Route path="/Vendors" element={<Vendors />} />
////                <Route path="/sign-up" element={<SignUp />} />
////                <Route path="*" element={<h1>Page Not Found</h1>} />
////                <Route path="/ViewAllVendors" element={<ViewAllVendors />} />
////                <Route path="/ViewAllUsers" element={<ViewAllUsers />} />
////                <Route path="/VendorsList" element={<VendorsList />} />
////                <Route path="/ViewAllInvoice" element={<ViewAllInvoice />} />
////                <Route path="/reports" element={<Reports />} />
////                <Route path="/ViewAllVendorReports" element={<ViewAllVendorReports />} />
////                <Route path="/ViewAllInvoiceDetails" element={<ViewAllInvoiceDetails />} />
////                <Route path="/vendor-details/:vendorId" element={<Vendors />} />

////            </Routes>
////        </UserProvider>

////    );

////}

////export default App;

//import React from 'react';

//import { Routes, Route } from 'react-router-dom';

//import { UserProvider } from './components/Context/UserContext';

//import { Home } from './components/Home';

//import Login from './components/Login';

//import SignUp from './components/SignUp';

//import MasterPage from './components/MasterPage';

//import NavMenu from './components/NavMenu';

//import Vendors from './components/Vendors';

//import ViewAllVendors from './components/ViewAllVendors';

//import ViewAllUsers from './components/ViewAllUsers';

//import VendorsList from './components/VendorsList';

//import ViewAllInvoice from './components/ViewAllInvoice';

//import RoleAssign from './components/RoleAssign'

//import Reports from '.././src/components/Reports';
//import ViewAllVendorReports from './components/ViewAllVendorReports';
//import ViewAllInvoiceDetails from './components/ViewAllInvoiceDetails';
//import './custom.css';

//function App() {

//    return (
//        <UserProvider>
//            <NavMenu />
//            <Routes>
//                <Route path="/" element={<Home />} />
//                <Route path="/login" element={<Login />} />
//                <Route path="/master-page" element={<MasterPage />} />
//                <Route path="/Vendors" element={<Vendors />} />
//                <Route path="/sign-up" element={<SignUp />} />
//                <Route path="*" element={<h1>Page Not Found</h1>} />
//                <Route path="/ViewAllVendors" element={<ViewAllVendors />} />
//                                <Route path="/reports" element={<Reports />} />
//                <Route path="/ViewAllUsers" element={<ViewAllUsers />} />
//                <Route path="/VendorsList" element={<VendorsList />} />
//                <Route path="/ViewAllInvoice" element={<ViewAllInvoice />} />
//                <Route path="/ViewAllVendorReports" element={<ViewAllVendorReports />} />
//                <Route path="/ViewAllInvoiceDetails" element={<ViewAllInvoiceDetails />} />
//                <Route path="/RoleAssign" element={<RoleAssign />} />
//            </Routes>
//        </UserProvider>

//    );

//}

//export default App;

import routes from './routesConfig';
import RouteDropdownPage from './components/RouteDropdownPage';  // new page
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { UserProvider } from './components/Context/UserContext';
import NavMenu from './components/NavMenu';
import { Home } from './components/Home';

function App() {
    return (
        <UserProvider>
            <NavMenu />
            <Routes>
                {routes.map(({ path, element: Element }) => (
                    <Route key={path} path={path} element={<Element />} />
                ))}
                <Route path="/all-routes" element={<RouteDropdownPage />} /> {/* New route for dropdown page */}
                <Route path="*" element={<h1>Page Not Found</h1>} />
            </Routes>
        </UserProvider>
    );
}

export default App;